/*eslint-disable*/
import {request} from '@/utils/request/request'
export function GetGongNengGaiKuangAndBarChart(query){
    return request ({
        url:'api/tongji/v1/GetGongNengGaiKuangAndBarChart',
        // url: 'api/guangfu/v1/GetGongNengGaiKuangAndBarChart',
        method:'get',
        params:query,
    })
}
// 功能概括导出按钮
export function GetGongNengGaiKuangexcel(query) {
    return request({
        url:'api/tongji/v1/GetGongNengGaiKuangAndBarChart',
        // url: '/api/guangfu/v1/PowerConsumerExcel',
        method: 'get',
        params: query,
    })
}

export function GetDianNengXaoHaoForPieChart(query){
    return request ({
        url:'api/tongji/v1/GetDianNengXaoHaoForPieChart',
        method:'get',
        params:query,
    })
}

export function GetDianNengXiaoHaoForBarChart(query){
    return request ({
        url:'api/tongji/v1/GetDianNengXiaoHaoForBarChart',
        method:'get',
        params:query,
    })
}

export function GetGetSankeyDataSource(query){
    return request ({
        url:'api/tongji/v1/GetSankeyDataSource',
        method:'get',
        params:query,
    })
}

